export default function validateSkills(skillsList) {
  const errors = [];
  const warnings = [];
  const list = skillsList || [];
  
  if (list.length === 0) {
    errors.push("Skills list is empty. Add your core technical and professional skills.");
  } else if (list.length < 3) {
    warnings.push("Add at least 3 skills to demonstrate your capabilities.");
  } else if (list.length > 30) {
    warnings.push("Skills list is very long. Keep only high-impact skills to prevent clutter.");
  }

  const percentage = list.length === 0 ? 0 : (list.length >= 3 ? 100 : 50);

  return {
    id: "skills",
    completed: errors.length === 0,
    percentage,
    errors,
    warnings
  };
}
